import { Component, Input }         from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';

import { MessagesService }                        from '../messages/messages.service';
import { Table }                                  from '../table/types/table';
import { TableQueryParameters }                   from '../table/types/table-query-parameters';
import { TableService }                           from '../table/table.service';
import { VehicleImportedHistoryActionsComponent } from './vehicle.imported-history.actions.component';
import { VehicleModel }                           from './models/vehicle';
import { VehiclesImportedHistoryModel }           from './typings/vehicles.imported-history';
import { VehiclesService }                        from './vehicles.service';

@Component({
  selector   : 'wor-vehicle-imported-history',
  template: require('./vehicle.imported-history.component.html')
})
export class VehicleImportedHistoryComponent {
  @Input() histories: Array<VehiclesImportedHistoryModel> = [];
  @Input() vehicle  : VehicleModel                        = {} as VehicleModel;

  collapsed = false;

  tableSettings : Table = {
    cache: {
      enabled: true,
      key    : this.vehiclesService.importedHistoryTableCacheKey
    },
    columns: [
      {
        field : 'post_date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'invoice_number',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'invoice_total',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onNotesClick: ( history : VehiclesImportedHistoryModel ) => this.viewNotes(history),
              onPrintClick: ( history : VehiclesImportedHistoryModel ) => this.view(history)
            }
          },
          enabled: true,
          factory: VehicleImportedHistoryActionsComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_HISTORY_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : this.tableService.getCachedPaging(this.vehiclesService.importedHistoryTableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 20, 50 ],
      queryCount: () => this.vehiclesService.getImportedHistoryCount(this.vehicle)
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: this.tableService.setSortingFromCache(this.vehiclesService.importedHistoryTableCacheKey, {
      direction: 'desc',
      field    : 'post_date'
    })
  };

  constructor (
    private messagesService : MessagesService,
    private tableService    : TableService,
    private translateService: TranslateService,
    private vehiclesService : VehiclesService
  ) {}

  get ( params : TableQueryParameters ) : Promise<Array<VehiclesImportedHistoryModel>> {
    return this.vehiclesService.getImportedHistory(this.vehicle, params)
      .then(( histories : Array<VehiclesImportedHistoryModel> ) => {
        this.histories = histories;

        return histories;
      })
      .catch(error => {
        this.messagesService.error(error);

        return this.histories;
      });
  }

  view ( history : VehiclesImportedHistoryModel ) : void {
    this.vehiclesService.viewImportedHistory(history);
  }

  viewNotes ( history : VehiclesImportedHistoryModel ) : void {
    this.vehiclesService.viewImportedHistoryNotes(history);
  }
}
